import React, { useState } from 'react';
import styled from 'styled-components';
import { AnimatePresence } from 'framer-motion';
import MenuLevel from './MenuLevel';

const breakpoints = {
  mobile: '768px',
  tablet: '1024px',
  desktop: '1440px',
};

const MenuContainer = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  padding: 2% 2% 2% 15%;
  display: flex;
  align-items: center;
  color: #fff;
  overflow: hidden;

  @media (max-width: ${breakpoints.mobile}) {
    padding: 2% 2% 2% 30%;
  }

  &.films {
    padding: 2% 15% 2% 2%;

    @media (max-width: ${breakpoints.mobile}) {
      padding: 2% 30% 2% 2%;
    }
  }

  &.level-campanas,
  &.level-spots,
  &.level-corporativo,
  &.level-postProduction,
  &.level-videoclips,
  &.level-social,
  &.level-fashion,
  &.level-retrato,
  &.level-sports,
  &.level-drinks,
  &.level-cultural,
  &.level-photoCampanas {
    padding: 2%;
    overflow: auto;
  }
`;

const FullscreenMenu = ({ type, onClose }) => {
  const [menuStack, setMenuStack] = useState(['main']);

  const isFilms = type === 'films';
  const direction = isFilms ? -1 : 1;

  const currentLevel = menuStack[menuStack.length - 1];

  const goTo = (level) => {
    setMenuStack((prev) => [...prev, level]);
  };

  const goBack = () => {
    setMenuStack((prev) => prev.slice(0, -1));
  };

  return (
    <MenuContainer
      style={{
        left: isFilms ? 0 : 'auto',
        right: isFilms ? 'auto' : 0,
      }}
      className={`menus ${isFilms ? 'films' : ''} level-${currentLevel}`}
    >
      <AnimatePresence mode="wait" custom={direction}>
        <MenuLevel
          key={currentLevel}
          level={currentLevel}
          type={type}
          direction={direction}
          onClose={onClose}
          goTo={goTo}
          goBack={goBack}
          isRoot={menuStack.length === 1}
        />
      </AnimatePresence>
    </MenuContainer>
  );
};

export default FullscreenMenu;
